module.exports = __webpack_public_path__ + "files/205fe8d32ba277810720f351651eef2e.png";